import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import MaskedInput from "react-text-mask";

const ContactForm = () => {
    const validationSchema = Yup.object({
        fullName: Yup.string().required("* İsim soyisim zorunludur."),
        phoneNumber: Yup.string()
            .matches(/^\d{3} \d{3} \d{4}$/, "* Telefon numarası 555 555 5555 formatında olmalıdır.")
            .required("* Telefon numarası zorunludur."),
        email: Yup.string().email("* Geçerli bir e-posta adresi giriniz.").required("* E-posta adresi zorunludur."),
        message: Yup.string().required("* Mesaj alanı boş bırakılamaz."),
    });

    const initialValues = {
        fullName: "",
        phoneNumber: "",
        email: "",
        message: "",
    };

    const handleSubmit = (values) => {
        console.log("Form verileri:", values);
        alert("Form başarıyla gönderildi!");
    };

    return (
        <div className="contact-form-content shadow">
            <h2>İletişim Formu</h2>
            <p className="mb-0">Sorularınız veya talepleriniz için bize kolayca ulaşabilirsiniz.</p>
            <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
                {({ setFieldValue }) => (
                    <Form className="mt-4">
                        <div className="mb-4">
                            <Field type="text" id="fullName" name="fullName" className="form-control" placeholder="İsim Soyisim" />
                            <ErrorMessage name="fullName" component="div" className="text-danger contact-error" />
                        </div>

                        <div className="mb-4">
                            <Field name="phoneNumber">
                                {({ field }) => (
                                    <MaskedInput
                                        {...field}
                                        mask={[
                                            /[1-9]/,
                                            /\d/,
                                            /\d/,
                                            " ",
                                            /\d/,
                                            /\d/,
                                            /\d/,
                                            " ",
                                            /\d/,
                                            /\d/,
                                            /\d/,
                                            /\d/,
                                        ]}
                                        placeholder="Telefon Numarası"
                                        guide={false}
                                        className="form-control"
                                        onChange={(e) => setFieldValue("phoneNumber", e.target.value)}
                                    />
                                )}
                            </Field>
                            <ErrorMessage name="phoneNumber" component="div" className="text-danger contact-error" />
                        </div>

                        <div className="mb-4">
                            <Field type="email" id="email" name="email" className="form-control" placeholder="E-posta Adresi" />
                            <ErrorMessage name="email" component="div" className="text-danger contact-error" />
                        </div>

                        <div className="mb-4">
                            <Field as="textarea" id="message" name="message" className="form-control" rows="4" placeholder="Mesajınız" />
                            <ErrorMessage name="message" component="div" className="text-danger contact-error" />
                        </div>

                        <button type="submit" className="btn-primary-v2 w-100">
                            Gönder
                        </button>
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default ContactForm;
